import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ShieldCheck, Sparkles } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { auth } from '../lib/firebase';
import { CompanionVerificationCenter } from '../components/verification/CompanionVerificationCenter';

export const VerificationCenterPage: React.FC = () => {
  const { currentUser, userProfile } = useAuth();
  const navigate = useNavigate();

  const companionId = auth.currentUser?.uid || '';
  const companionName = userProfile?.displayName || userProfile?.name || 'Companion Member';
  const companionEmail = userProfile?.email || '';

  return (
    <div className="min-h-screen bg-[#0a0718] text-slate-100 pt-24 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto space-y-6">
        {/* Back Link */}
        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={() => navigate('/companion/dashboard')}
            className="flex items-center gap-2 text-xs font-bold text-slate-400 hover:text-white transition cursor-pointer"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back to Companion Dashboard</span>
          </button>

          <div className="flex items-center gap-2 text-xs text-purple-400 font-mono font-bold">
            <ShieldCheck className="w-4 h-4 text-emerald-400" />
            <span>Official Identity Verification Desk</span>
          </div>
        </div>

        {/* Verification Center */}
        <CompanionVerificationCenter
          companionId={companionId}
          companionName={companionName}
          companionLegalName={(userProfile as any)?.legalName}
          companionEmail={companionEmail}
        />
      </div>
    </div>
  );
};
